'use client'
import {
  Sheet,
  SheetContent,
  SheetTrigger
} from '@/components/ui/sheet'
import { Menu } from 'lucide-react'
import { GroupedArticles, SidebarNav } from './sidebar-nav'

export function MobileNavSheet(props: { groupedArticles: GroupedArticles }) {
  return (
    <Sheet>
      <SheetTrigger asChild>
        <button type='button' className='text-muted-foreground hover:text-foreground'>
          <span className='sr-only'>Navigation</span>
          <Menu className='h-5 w-5 shrink-0' />
        </button>
      </SheetTrigger>
      <SheetContent side='left' className='overflow-y-auto'>
        <SidebarNav groupedArticles={props.groupedArticles} />
      </SheetContent>
    </Sheet>
  )
}
